const HANDOFF_STORAGE_KEY = 'interviewFlow:handoffPrefill';

export function handoffStorageKey(appId) {
  return `${HANDOFF_STORAGE_KEY}:${appId || 'default'}`;
}

/** Build handoff payload from a screening queue row. */
export function buildHandoffFromRow(row, copyFields) {
  const fields = Array.isArray(copyFields) && copyFields.length
    ? copyFields
    : ['candidateName', 'roleApplied', 'screeningBucket', 'screeningScore'];
  const out = {};
  fields.forEach((field) => {
    const aliases = {
      candidateName: ['candidateName', 'candidate'],
      roleApplied: ['roleApplied', 'role'],
      screeningBucket: ['screeningBucket', 'bucket'],
      screeningScore: ['screeningScore', 'score'],
    };
    const keys = aliases[field] || [field];
    for (const k of keys) {
      if (row[k] != null && row[k] !== '') {
        out[field] = row[k];
        break;
      }
    }
  });
  return out;
}

export function shouldTriggerHandoff(row, handoffMeta) {
  if (!handoffMeta || !row || typeof row !== 'object') return false;
  const bucket = String(row.bucket ?? row.screeningBucket ?? '').toLowerCase();
  if (bucket && bucket !== 'pass') return false;
  return Boolean(
    handoffMeta.companionBundleId
    || handoffMeta.companionAppId
    || handoffMeta.targetPhaseId,
  );
}

export function storeHandoffPrefill(appId, prefill) {
  try {
    sessionStorage.setItem(handoffStorageKey(appId), JSON.stringify({
      t: Date.now(),
      input: prefill,
    }));
  } catch {
    /* ignore quota */
  }
}

export function readHandoffPrefill(appId) {
  try {
    const raw = sessionStorage.getItem(handoffStorageKey(appId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.input && typeof parsed.input === 'object' ? parsed.input : null;
  } catch {
    return null;
  }
}

export function clearHandoffPrefill(appId) {
  try {
    sessionStorage.removeItem(handoffStorageKey(appId));
  } catch {
    /* ignore */
  }
}
